import {
  checkForDirectCTA, fetchSiteInformation, logInitialPageLoad,
  markScriptInstalled, injectBookingPixel,
  initPixelPostMessageListener, checkIfURLContainsConfirmation,
} from './functions';
import { bookingsEmbedDebugLog } from './utils';

async function fireLogicWithSiteId(siteId: string | null, hotelParam: string | null): Promise<void> {

  const siteInfo = await fetchSiteInformation(siteId, hotelParam);
  if (siteInfo == null) {
    bookingsEmbedDebugLog('Unable to get site info for Hovr booking script.');
    return;
  }

  if (siteId == null || siteId === '') {
    siteId = siteInfo.id;
  }

  siteInfo.id = siteId;
  if (!siteInfo.bookingScriptInstalled) {
    markScriptInstalled(siteId, hotelParam);
  }

  // check if url contains a direct CTA
  checkForDirectCTA();

  logInitialPageLoad(siteInfo);

  /**
   * if the cookie is not populated yet (even if we are on the confirmation page)
   * inject the booking pixel and start listening for post messages - this will
   * then check prior logging any sort of analytics - inside the post messengaer
   * listener is the same logic as the second half of the if else statement
   * This will handle the event we are just on the confirmation page
   *
   * if the cookie is already populated - it ran prior to the confirmation page being loaded
   * so all we need to do is check if we are on the confirmation page and if so,
   * log the confirmation values
   */

  const hovrEngagedCookie = localStorage.getItem('hovrEngaged');

  bookingsEmbedDebugLog('Hovr Booking Embed - hovrEngagedCookie: ', hovrEngagedCookie);

  if (hovrEngagedCookie == null || hovrEngagedCookie === '') {
    bookingsEmbedDebugLog('Inject Pixel and init post message listener. HovrEngaged cookie not set.');
    initPixelPostMessageListener(siteInfo, null);
    injectBookingPixel(siteId, hotelParam);
  } else {
    bookingsEmbedDebugLog('Found engaged cookie. checking if URL contains confirmation.');
    let hovrEngaged = false;
    if (hovrEngagedCookie === 'true') {
      hovrEngaged = true;
    }

    const hovrEngagedDateCookie = localStorage.getItem('hovrEngagedDate');
    const hovrSessionId = localStorage.getItem('hovrSessionId');
    const thirtyDayTrackingID = localStorage.getItem('hovrThirtyDayTrackingID');
    const siteId = localStorage.getItem('siteId');

    checkIfURLContainsConfirmation(
      siteInfo,
      {
        hovrEngaged,
        hovrEngagedDate: hovrEngagedDateCookie,
        hovrSessionId,
        thirtyDayTrackingID,
        siteId,
      },
    );
  }

  // add a mutation observer for single page applications
  let previousUrl: string = '';
  const observer = new MutationObserver(() => {
    if (window.location.href !== previousUrl) {
      previousUrl = window.location.href;
      if (previousUrl !== '') {
        logInitialPageLoad(siteInfo);
      }
      if (hovrEngagedCookie == null || hovrEngagedCookie === '') {
        initPixelPostMessageListener(siteInfo, null);
        injectBookingPixel(siteId, hotelParam);
      } else {
        let hovrEngaged = false;
        if (hovrEngagedCookie === 'true') {
          hovrEngaged = true;
        }

        const hovrEngagedDateCookie = localStorage.getItem('hovrEngagedDate');
        const hovrSessionId = localStorage.getItem('hovrSessionId');
        const thirtyDayTrackingID = localStorage.getItem('hovrThirtyDayTrackingID');
        const siteId = localStorage.getItem('siteId');
        checkIfURLContainsConfirmation(
          siteInfo,
          {
            hovrEngaged,
            hovrEngagedDate: hovrEngagedDateCookie,
            hovrSessionId,
            thirtyDayTrackingID,
            siteId,
          },
        );
      }
    }
  });
  const configuration = { subtree: true, childList: true };
  observer.observe(document, configuration);
}

async function init() {
  const hovrBookingScript: HTMLElement | null = document.getElementById('hovr-booking-script');

  if (hovrBookingScript == null) {
    throw new Error('Hovr booking script not found');
  }

  let siteId: string | null = hovrBookingScript.getAttribute('data-id');
  let hotelParam: string | null = null;

  if (siteId == null) {
    // check for the hotel query param on sysnxis
    hotelParam = new URL(window.location.href).searchParams.get('hotel');
  }

  if ((siteId === '' || siteId == null) && (hotelParam === '' || hotelParam == null)) {
    throw new Error('Hovr booking script data-id attribute is empty and no hotel query param found');
  }

  if (siteId === 'ignore') {
    // ignore gets used when we have multiple front end sites useing the same script
    // sandos primary use case
    initPixelPostMessageListener(null, fireLogicWithSiteId);
    injectBookingPixel('', '');
  } else {
    fireLogicWithSiteId(siteId, hotelParam);
  }
}
init();
